$('.image-slider').slick({
	dots: false,
	dotsClass: 'slide-dots',
	infinite: true,
	speed: 700,
	slidesToShow: 1,
	slidesToScroll: 2,
	arrows: true,
	adaptiveHeight: true,
	prevArrow:
		'<button class="slide-arrow prev-arrow ps-arrow-left"><img src="https://cdn.shopify.com/s/files/1/0623/2703/0015/files/left-arrow.png?v=1645678822"></button>',
	nextArrow:
		'<button class="slide-arrow next-arrow ps-arrow-right"><img src="https://cdn.shopify.com/s/files/1/0623/2703/0015/files/right-arrow.png?v=1645678809"></button>',
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
			},
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
			},
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false,
			},
		},
	],
})
$('.review-slider').slick({
	dots: true,
	dotsClass: 'slide-dots',
	infinite: true,
	speed: 1500,
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	autoplay: true,
	infinite: true,
	prevArrow:
		'<button class="slide-arrow prev-arrow ps-arrow-left"><img src="https://cdn.shopify.com/s/files/1/0623/2703/0015/files/left-arrow.png?v=1645678822"></button>',
	nextArrow:
		'<button class="slide-arrow next-arrow ps-arrow-right"><img src="https://cdn.shopify.com/s/files/1/0623/2703/0015/files/right-arrow.png?v=1645678809"></button>',
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				dots: true,
			},
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
			},
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
			},
		},
	],
})
$('ul.tabs li').click(function () {
	var tab_id = $(this).attr('data-tab')
	$('ul.tabs li').removeClass('current')
	$('.tab-content').removeClass('current')
	$(this).addClass('current')
	$('#' + tab_id).addClass('current')
})

$('.mobileSlider').slick({
	dots: false,
	infinite: true,
	slidesToShow: 2,
	slidesToScroll: 1,
	arrows: true,
	prevArrow:
		'<button class="slide-arrow prev-arrow ps-arrow-left"><img src="https://cdn.shopify.com/s/files/1/0623/2703/0015/files/left-arrow.png?v=1645678822"></button>',
	nextArrow:
		'<button class="slide-arrow next-arrow ps-arrow-right"><img src="https://cdn.shopify.com/s/files/1/0623/2703/0015/files/right-arrow.png?v=1645678809"></button>',
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
			},
		},
		{
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
			},
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
			},
		},
	],
})

$('.product-form__input .select__select').change(function () {
	setTimeout(function () {
		var getcurrvariantid = $('.getvariantid').val()
		var qty = $('.quantity__input').val()
		$('.allVariant option').each(function () {
			var thisvarif = $(this).val()
			if (thisvarif == getcurrvariantid) {
				var thisPrice = $(this).attr('data-price')
				thisPrice = (thisPrice * qty) / 100
				thisPrice = thisPrice
				var add_price = 0
				$('.additionUpsell').each(function () {
					var pro_id = $(this).attr('data-id')
					var text = $('#getVaraint-' + pro_id + ' option:selected').text()
					if (text != 0) {
						$('.prop-' + pro_id).val(text)
						var price = $('#getVaraint-' + pro_id + ' option:selected').attr('data-price')
						var add_price1 = price / 100
						add_price += parseFloat(add_price1)
					} else {
						$('.prop-' + pro_id).val('')
					}
				})
				setTimeout(function () {
					thisPrice = (thisPrice + add_price).toFixed(2)
					thisPrice = thisPrice.replace('.', ',')
					$('.totalPrice').text('Totale : ' + thisPrice + ' €')
				}, 500)
			}
		})
	}, 500)
})

// Order Online page js start

$('.quantity__button').click(function () {
	setTimeout(function () {
		var getcurrvariantid = $('.getvariantid').val()
		var qty = $('.quantity__input').val()
		$('.allVariant option').each(function () {
			var thisvarif = $(this).val()
			if (thisvarif == getcurrvariantid) {
				var thisPrice = $(this).attr('data-price')
				thisPrice = (thisPrice * qty) / 100
				thisPrice = thisPrice
				var add_price = 0
				$('.additionUpsell').each(function () {
					var pro_id = $(this).attr('data-id')
					var text = $('#getVaraint-' + pro_id + ' option:selected').text()
					if (text != 0) {
						$('.prop-' + pro_id).val(text)
						var price = $('#getVaraint-' + pro_id + ' option:selected').attr('data-price')
						var add_price1 = price / 100
						add_price += parseFloat(add_price1)
					} else {
						$('.prop-' + pro_id).val('')
					}
				})
				setTimeout(function () {
					thisPrice = (thisPrice + add_price).toFixed(2)
					thisPrice = thisPrice.replace('.', ',')
					$('.totalPrice').text('Totale : ' + thisPrice + ' €')
				}, 500)
			}
		})
	}, 500)
})

$('body').on('click', '.multipleProduct', function (e) {
	e.preventDefault()
	var available_ids = []
	var available_qty = []
	var pName = []
	var pValue = []

	$('.additionUpsell')
		.each(function () {
			var pro_id = $(this).attr('data-id')
			var text = $('#getVaraint-' + pro_id + ' option:selected').text()
			if (text != 0) {
				var variant_id = parseInt($('.upsell_' + pro_id).val())
				var line_item = $('.prop-' + pro_id).clone()
				//$(".lineitem").append(line_item);
				//           alert(variant_id);
				var qty = parseInt($('#getVaraint-' + pro_id + ' option:selected').val())
				available_ids.push(variant_id)
				available_qty.push(qty)
				var pn = $('.prop-' + pro_id).attr('ptitle')
				pName.push(pn)
				var pv = parseInt($('.prop-' + pro_id).val())
				pValue.push(pv)
			}
		})
		.promise()
		.done(function () {
			//         console.log("All done");
		}) //each qty ends

	if (available_ids.length == 0) {
		$('#AddToCart').click()
	} else {
		for (var i = 0; i < available_ids.length; i++) {
			;(function (i) {
				//we are applying setTimeout strategy to avoid fast looping what causes add to cart failure.
				setTimeout(function () {
					var formContents = available_ids[i]
					var params = {
						type: 'POST',
						url: '/cart/add.js',
						data: 'quantity=' + available_qty[i] + '&id=' + available_ids[i],
						// data: {
						//     quantity:available_qty[i],
						//     id:available_ids[i],
						//     properties: {
						//      "Quantità" : pValue[i]
						//     }
						//   },
						dataType: 'json',
						success: function (line_item) {
							console.log('success! - ' + line_item.title)
							console.log('---' + i + '-----')
							var iteration_length = i + 1
							if (iteration_length == available_ids.length) {
								$('.Spin-pro').addClass('hide')
								$('.Text-pro').show()
								$('#AddToCart').click()
							}
						},
						error: function () {
							console.log('fail')
						},
					}
					$.ajax(params)
				}, 1000 * i)
			})(i)
		}
	}
})

function myFunction() {
	document.getElementById('myDropdown').classList.toggle('show')
}
window.onclick = function (event) {
	if (!event.target.matches('.dropbtn')) {
		var dropdowns = document.getElementsByClassName('dropdown-content')
		var i
		for (i = 0; i < dropdowns.length; i++) {
			var openDropdown = dropdowns[i]
			if (openDropdown.classList.contains('show')) {
				openDropdown.classList.remove('show')
			}
		}
	}
}
// $(document).ready(function(){
// 	$('a[href^="#"]').on('click',function (e) {
// 	    e.preventDefault();
// 	    var target = this.hash;
// 	    var $target = $(target);
// 	    $('html, body').stop().animate({
// 	        'scrollTop': $target.offset().top
// 	    }, 900, 'swing', function () {
// 	        // window.location.hash = target;
// 	    });
// 	});
// });

document.addEventListener('DOMContentLoaded', function () {
	function isIE() {
		const ua = window.navigator.userAgent
		const msie = ua.indexOf('MSIE ')
		const trident = ua.indexOf('Trident/')

		return msie > 0 || trident > 0
	}

	if (!isIE()) return
	const hiddenInput = document.querySelector('#{{ product_form_id }} input[name="id"]')
	const noScriptInputWrapper = document.createElement('div')
	const variantSwitcher =
		document.querySelector('variant-radios[data-section="{{ section.id }}"]') ||
		document.querySelector('variant-selects[data-section="{{ section.id }}"]')
	noScriptInputWrapper.innerHTML = document.querySelector(
		'.product-form__noscript-wrapper-{{ section.id }}'
	).textContent
	variantSwitcher.outerHTML = noScriptInputWrapper.outerHTML

	document.querySelector('#Variants-{{ section.id }}').addEventListener('change', function (event) {
		hiddenInput.value = event.currentTarget.value
	})
})
$('.head').click(function () {
	$(this).toggleClass('active')
	$(this).parent().find('.arrow').toggleClass('arrow-animate')
	$(this).parent().find('.content').slideToggle(280)
})

if ($(window).width() < 767) {
	$('.ps-desktop-video').hide()
	$('.ps-mobile-video').show()
} else {
	$('.ps-desktop-video').show()
	$('.ps-mobile-video').hide()
}

$(window).on('resize', function () {
	if ($(window).width() < 767) {
		$('.ps-desktop-video').hide()
		$('.ps-mobile-video').show()
	} else {
		$('.ps-desktop-video').show()
		$('.ps-mobile-video').hide()
	}
})

